import script from "./PasswordUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordUpdate.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordUpdate.vue?vue&type=style&index=0&id=8424faba&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8424faba"]])

export default __exports__